export function maskDutchDate(value, previousValue = '') {
  const deleting = String(value || '').length < String(previousValue || '').length;
  const digits = String(value || '').replace(/\D/g, '').slice(0, 8);
  if (digits.length < 2) return digits;
  if (digits.length === 2) return deleting ? digits : `${digits}-`;
  if (digits.length < 4) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  if (digits.length === 4) return deleting
    ? `${digits.slice(0, 2)}-${digits.slice(2)}`
    : `${digits.slice(0, 2)}-${digits.slice(2)}-`;
  return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`;
}

export function dutchDateToIso(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length !== 8) return null;

  const day = Number(digits.slice(0, 2));
  const month = Number(digits.slice(2, 4));
  const year = Number(digits.slice(4, 8));
  const candidate = new Date(Date.UTC(year, month - 1, day));

  if (
    year < 1900
    || candidate.getUTCFullYear() !== year
    || candidate.getUTCMonth() !== month - 1
    || candidate.getUTCDate() !== day
    || candidate > new Date()
  ) return null;

  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function isoDateToDutch(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
  return match ? `${match[3]}-${match[2]}-${match[1]}` : '';
}
